import * as THREE from "three";

const projected = new THREE.Vector3();

export function pickNearest(positions, camera, ndcX, ndcY, width, height, time, phases, maxPixels = 14, visible) {
  let best = -1;
  let bestD = maxPixels * maxPixels;
  const count = positions.length / 3;
  for (let i = 0; i < count; i += 1) {
    if (visible && visible[i] < 0.5) continue;
    const phase = phases[i];
    projected.set(
      positions[i * 3] + Math.sin(time * 0.13 + phase) * 0.92,
      positions[i * 3 + 1] + Math.cos(time * 0.11 + phase * 1.7) * 0.68,
      positions[i * 3 + 2] + Math.sin(time * 0.09 + phase * 0.61) * 0.88,
    );
    projected.project(camera);
    if (projected.z < -1 || projected.z > 1) continue;
    const sx = (projected.x * 0.5 + 0.5) * width;
    const sy = (-projected.y * 0.5 + 0.5) * height;
    const mx = (ndcX * 0.5 + 0.5) * width;
    const my = (-ndcY * 0.5 + 0.5) * height;
    const dx = sx - mx;
    const dy = sy - my;
    const d2 = dx * dx + dy * dy;
    if (d2 < bestD) {
      bestD = d2;
      best = i;
    }
  }
  return best;
}

export function collectNearbyLabels(positions, phases, sizes, camera, time, limit = 90, visible) {
  const count = positions.length / 3;
  const camPos = camera.position;
  const scored = [];
  for (let i = 0; i < count; i += 1) {
    if (visible && visible[i] < 0.5) continue;
    const phase = phases[i];
    const x = positions[i * 3] + Math.sin(time * 0.13 + phase) * 0.92;
    const y = positions[i * 3 + 1] + Math.cos(time * 0.11 + phase * 1.7) * 0.68;
    const z = positions[i * 3 + 2] + Math.sin(time * 0.09 + phase * 0.61) * 0.88;
    projected.set(x, y, z).project(camera);
    if (projected.z < -1 || projected.z > 1) continue;
    if (projected.x < -1.15 || projected.x > 1.15) continue;
    if (projected.y < -1.15 || projected.y > 1.15) continue;
    const dx = x - camPos.x;
    const dy = y - camPos.y;
    const dz = z - camPos.z;
    const dist = Math.sqrt(dx * dx + dy * dy + dz * dz);
    if (dist > 48) continue;
    const closeness = 1 / Math.max(4, dist);
    scored.push({
      index: i,
      x,
      y,
      z,
      ndcX: projected.x,
      ndcY: projected.y,
      dist,
      score: closeness * sizes[i],
    });
  }
  scored.sort((a, b) => b.score - a.score);
  return scored.slice(0, limit);
}
